<p>&nbsp;</p>    <p>&nbsp;</p>
    <div>
        <div class="text-center">
            <h2 class="text-2xl confirmation__heading">Kontakt z Administracją portalu plytowisko.pl:</h2>
            <ul class="mt-4">
                <li class="space-x-2"><span>Email: <a>kontakt@plytowisko.pl</a></span></li>
                <li class="space-x-2"><span>Tel: +48 796 315 065</span></li>
            </ul>
        </div>
    </div>